export const submitBtn = {
  marginTop: '8px',
  height: 'auto',
  width: 'auto',
  marginLeft: '10px',
};
